import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import { formatDirectionValue } from "./directionFormatter";

/**
 * DirectionCellRenderer
 *
 * Displays direction and counterparty information with real-time Zustand updates
 * Works in conjunction with directionValueFormatter for copy/paste support
 */
const DirectionCellRenderer = (params: any) => {
  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);

  // Subscribe to Zustand store for reactive updates, fallback to fullTradeData for historical trades
  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade =
    currentTradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;

  // Guard against an unhydrated store / missing trade — re-renders reactively
  // once tradeData arrives via the Zustand subscription above.
  if (!thisTrade) return <div data-testid="directionCellContainer" />;

  // Use shared formatting logic
  const formattedValue = formatDirectionValue(params, thisTrade);

  return <div data-testid="directionCellContainer">{formattedValue}</div>;
};

export default DirectionCellRenderer;
